import { gql } from '../../utils/helper';

export const updateFooterSettings = gql`
  mutation updateFooterSettings($id: uuid!, $set: publicationFooterSettings_set_input!) {
    update_publicationFooterSettings_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      publicationId
      backgroundColors
      fontColors
      mediaLinks
    }
  }
`;
